module.exports = "/images/download-icon.png?3a28aa4f205e084962bda32d03c4c444";